import { ApiError } from '@beeboard/common';
import { useUiStore } from '@/store/uiStore';

export const useAlerts = () => {
  const uiStore = useUiStore();

  function success(message?: string): void {
    if (!message) {
      message = $t('message.saveSuccess');
    }
    uiStore.alert('success', message);
  }

  function error(err?: unknown): void {
    const defaultMessage = $t('errors.somethingWentWrong');
    if (!err) {
      err = defaultMessage;
    }

    console.error(err);

    if (err instanceof ApiError) {
      return uiStore.alert(
        'danger',
        err.body?.message || err.message || defaultMessage,
      );
    }

    if (err instanceof Error) {
      return uiStore.alert('danger', err.message || defaultMessage);
    }

    if (typeof err === 'string') {
      uiStore.alert('danger', err);
    } else if (Array.isArray(err)) {
      err.forEach((msg) => uiStore.alert('danger', msg));
    }
  }

  function warning(message: string): void {
    uiStore.alert('warning', message);
  }

  return {
    success,
    error,
    warning,
  };
};
